import React from 'react';
import { Typography } from '@mui/material';
import TransactionAllocator, {
  Transaction,
} from 'components/TransactionAllocator';
import { CurrencyCode, FxDataFeed } from 'further-types/lp/vehicle';
import AppAccordion from 'components/AppAccordion';
import { numberToCurrencyString } from 'further-ui/utils';
import Row from 'components/Layout/Row';
import { useFormContext } from 'react-hook-form';
import { PartnerTransfersFormValues } from '../hooks/usePartnerTransfersForm';
import { sumBy } from 'lodash';

type CapitalActionTransactionAllocatorProps = {
  actionId: string;
  actionName: string;
  transactions: Array<Transaction>;
  transactionTypeOptions: Array<{ label: string; value: string | null }>;
  vehicle: {
    _id: string;
    baseCurrency: CurrencyCode;
    fxDataFeed: FxDataFeed;
  };
  savedTransactions?: Record<string, Array<Transaction>>;
};

const CapitalActionTransactionAllocator: React.FC<
  CapitalActionTransactionAllocatorProps
> = ({
  actionId,
  actionName,
  transactions,
  transactionTypeOptions,
  vehicle,
  savedTransactions,
}) => {
  const { setValue, getValues } = useFormContext<PartnerTransfersFormValues>();

  const currentTransactions = savedTransactions?.[actionId] ?? transactions;

  const onTransactionChange = (updatedTransactions: Array<Transaction>) => {
    const existingTransactions = getValues('capitalActionTransactions') ?? {};

    setValue('capitalActionTransactions', {
      ...(existingTransactions ?? {}),
      [actionId]: updatedTransactions.map((t) => ({
        ...t,
        id: t.id?.toString(),
        amountExVatLcy: t.amountExVatLcy ?? 0,
        amountIncVatLcy: t.amountIncVatLcy ?? 0,
        vatRate: 0,
      })),
    });
  };

  const totalAmount = sumBy(currentTransactions, 'amountIncVatTcy');

  return (
    <AppAccordion title={actionName} defaultExpanded>
      <AppAccordion.Summary>
        <Row>
          <Typography>
            {numberToCurrencyString(totalAmount, {
              currency: vehicle.baseCurrency,
            })}
          </Typography>
        </Row>
      </AppAccordion.Summary>
      <AppAccordion.Content>
        <TransactionAllocator
          transactionTypeOptions={transactionTypeOptions}
          transactions={currentTransactions}
          onChange={onTransactionChange}
          transactionCurrency={vehicle.baseCurrency}
          fxRate={null}
          vehicle={vehicle}
        />
      </AppAccordion.Content>
    </AppAccordion>
  );
};

export default CapitalActionTransactionAllocator;
